import React, { useState, useEffect } from 'react'
import objectPath from 'object-path'
import { useRouteMatch, useLocation } from 'react-router-dom'

import { getForm, getPage } from 'designer/component/action/Design'
import ExternalComponent from './index'
import FormLoading from 'components/Loader/FormLoading'

const Designer = ({
  apiReloadToken = 0,
  component = {
    data: {
      /*  
        รับ data จาก component และส่งไป designer
        ต้องสร้าง prop ชื่อ "data" ประเภท "input/formData" ใน designer 
        เพื่อรับ data จาก component ไปยัง input หรือ form data ใน designer
      */
    },
    setData: () => {
      // set state ของ data จาก component
    },
    defaultData: {
      // รับ structure data เพื่อใช้ผูก data จาก designer และส่งกลับไป component
    },
    defaultProps: {
      /* 
        รับค่า prop เพื่อผูกค่าที่ส่งมาจาก component เข้าในระบบ designer
        ต้องสร้าง prop ประเภท "system" ใน designer เพื่อรับค่า prop
        เช่น "isPublic" : 1 ให้สร้าง prop ชื่อ "isPublic" ใน designer
      */
    },
  },
  code = {
    form: '', // รับ form code
    page: '', // รับ page code
    widget: '', // รับ widget code
  },
  callback = {
    /* 
      รับ callback สำหรับ call function จาก component ผ่านปุ่มใน designer
      ต้องสร้าง prop ประเภท "callback" ใน designer เพื่อรับค่า callback
      เช่น "saveCallback" : onSave() ให้สร้าง prop ชื่อ "saveCallback" ใน designer
    */
  },
  tableProps = {
    isDetailPanel: false,
    renderTableData: () => {},
  },
}) => {
  const { data, setData } = component

  const [render, setRender] = useState(false)
  const [uischema, setUischema] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const { form, page, widget } = code
  const match = useRouteMatch()
  const location = useLocation()
  let search = location.search || []
  let pathParams = match.params
  let urlSearchParams = new URLSearchParams(search)
  let queryParams = Object.fromEntries([...urlSearchParams])

  // update data ที่ได้จาก designer ไปยัง component
  const onUpdateData = (designerData) => {
    let newData = objectPath.get(designerData, `data`)
    setData({ ...data, ...newData })
  }

  // update data ที่ได้จาก row table ใน designer ไปยัง component
  const onSelectRow = (rowData) => {
    onUpdateData(null, rowData)
    setRender(true)
  }

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  useEffect(() => {
    let isMounted = true

    const loadDesigner = async () => {
      let design = null
      let type = ''
      let useFormData = true
      let uischema = {}
      setIsLoading(true)
      try {
        if (widget) {
          type = 'widget'
          objectPath.set(uischema, 'type', type)
          objectPath.set(uischema, 'ui', true)
          if (isMounted) {
            setUischema(uischema)
          }
        } else {
          if (form) {
            type = 'form'
            design = await getForm(form)
          } else if (page) {
            type = 'page'
            design = await getPage(
              page,
              pathParams,
              queryParams,
              location,
              useFormData
            )
          }
          if (!objectPath.get(design, 'formDesign.formDesignId')) return
          let designerProps =
            objectPath.get(design, 'jsonForm.designerPropsData.receive') || []
          let receiveProps = designerProps
          objectPath.set(uischema, 'ui.close', false)
          objectPath.set(uischema, 'ui.formDesign', design.formDesign)
          objectPath.set(uischema, 'ui.jsonForm', design.jsonForm)
          objectPath.set(uischema, 'ui.receiveProps', receiveProps)
          objectPath.set(uischema, 'title', design.formDesign.name)
          objectPath.set(uischema, 'type', type)
          objectPath.set(uischema, 'isCustomComponent', true)
          if (isMounted) {
            setUischema(uischema)
          }
        }
      } catch (error) {
        console.error('There was an error!', error)
      } finally {
        if (isMounted) {
          setIsLoading(false)
        }
      }
    }

    loadDesigner()

    return () => {
      isMounted = false
    }
  }, [])

  if (!uischema.ui) {
    return isLoading ? <FormLoading /> : null
  }

  return (
    <ExternalComponent
      externalCode={widget}
      designerData={data}
      data={data}
      onUpdateData={onUpdateData}
      onSelectRow={onSelectRow}
      uischema={uischema}
      designCode={form || page}
      callback={{
        ...callback,
        '@onSelectRow': onSelectRow,
      }}
      isDetailPanel={tableProps?.isDetailPanel}
      isExternalDesign={true}
      apiReloadToken={apiReloadToken}
    />
  )
}

Designer.defaultProps = {
  component: {
    data: {},
    setData: () => {},
    defaultData: {},
    defaultProps: {},
  },
  code: {
    form: '',
    page: '',
    widget: '',
  },
  callback: {},
}

export default Designer
